import React from 'react'
import Contactus from '../Common/Contactus'
import MainBanner from '../page_content/MainBanner'
import whiterightarrow from "../../assets/images/white-rightarrow.svg";
import blackrightarrow from "../../assets/images/blackrightarrow.svg";
import sideCartimg from "../../assets/images/examenimg.png";
import closeicon from "../../assets/images/closeicon.svg";
import Header from '../Common/Header';
const Examen = () => {
    return (
        <>
                <Header/>

         <div>
            <MainBanner page="PRODUCTS" />
            <section className=" aboutsection2" id="single-product">
                <div className="container ">
                    <div className="bg-white">
                        <div className="text-section">
                            <h2 className="text-purple">
                                Examen

                            </h2>
                            <p className="fw-medium">Driving test and license </p>
                            <div>
                                Online Marketplace:&nbsp;The Examen Website Project is dedicated to providing an efficient and user-friendly platform for individuals preparing to apply for their driving licenses. This website aims to streamline the testing process by offering a comprehensive suite of resources, including practice exams, study materials, and interactive tools to help users successfully pass their driving tests.


                            </div>
                            <div>
                                Product Catalogue:&nbsp;
                                The platform will feature a wide array of practice tests that closely simulate the actual driving license examination, covering essential topics such as road signs, traffic laws, and safe driving practices. Users can track their progress and identify areas needing improvement, enhancing their readiness for the real exam.

                            </div>
                            <div className="d-flex">
                                <a
                                    href="#demo-modal"
                                    className="btn btn-black btn-purple  text-white"
                                >
                                    View Project
                                    <img src={whiterightarrow} alt="" />
                                </a>
                            </div>
                        </div>
                        <div className="image-section">
                            <img src={sideCartimg} alt="" />
                        </div>
                    </div>
                    <div id="demo-modal" className="modal">
                        <div className="modal__content">
                            <h2 className="text-purple">Get A Free Demo</h2>
                            <p className="fw-medium">
                                Embrace Opportunity: A Pathway to Success
                            </p>
                            <div className="form-container">
                                <div className="form-group">
                                    <label htmlFor="product">Select Product:</label>
                                    <select id="product" name="product">
                                        <option value="product1">Comercio</option>
                                        <option value="product2">Product 2</option>
                                        <option value="product3">Product 3</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="name">Name:</label>
                                    <input
                                        type="text"
                                        id="name"
                                        placeholder="MCL"
                                        name="name"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        type="email"
                                        placeholder="info@gmail.com"
                                        id="email"
                                        name="email"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="phone">Phone:</label>
                                    <input
                                        type="tel"
                                        placeholder="+91 9896570012"
                                        id="phone"
                                        name="phone"
                                        required
                                    />
                                </div>
                                <div className="form-group full-width">
                                    <label htmlFor="message">Message:</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        placeholder="Enter your message here"
                                        required
                                        defaultValue={""}
                                    />
                                </div>
                                <div className="form-group full-width button">
                                    <button className="btn btn-black" type="submit">
                                        Get a demo
                                    </button>
                                </div>
                            </div>
                            <a href="#" className="modal__close">
                                <img src={closeicon} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className id="Comercio-discription">
                <div className="container ">
                    <div className="card-container bg-white text-gray">
                        <div>
                            <span className="fw-semi-bold">
                                Comprehensive Practice Tests:
                                &nbsp;</span>
                            The platform offers a variety of practice exams that closely mimic the actual driving license test, covering crucial topics like road signs, traffic laws, and safe driving techniques.

                        </div>
                        <div>
                            <span className="fw-semi-bold">
                            Progress Tracking:
                            </span>
                            Users can monitor their performance over time, identifying strengths and weaknesses to tailor their study efforts and improve their chances of success.

                        </div>
                        <div>
                            <span className="fw-semi-bold">Study Guides & Resources:
                                &nbsp;</span>
                                Detailed study materials, including guides and instructional videos, are available to reinforce learning and ensure users are well-prepared for the driving exam.

                        </div>

                    </div>
                    <div className="card-container bg-white text-gray">
                        <div>
                            <span className="fw-semi-bold">
                            Community Forum:

                                &nbsp;
                            </span>
                            A dedicated space where users can engage with peers and instructors, share study tips, and ask questions about the driving test process, fostering a supportive learning environment.

                        </div>
                        <div>
                            <span className="fw-semi-bold">
                            User-Friendly Registration System:

                                &nbsp;
                            </span>
                            &nbsp;The website allows users to create profiles, schedule their tests, and receive reminders, streamlining the entire application process for a driving license.


                        </div>
                        <div>
                            <span className="fw-semi-bold">
                            Mobile Optimization:&nbsp;&nbsp;
                            </span>
                            &nbsp;The platform is fully optimized for mobile devices, enabling users to study and prepare for their driving tests conveniently from anywhere at any time.



                        </div>
                    </div>
                </div>
            </section>
            <Contactus />
        </div></>
    )
}

export default Examen